// extracted by mini-css-extract-plugin
export default {"touchTarget":"AppointmentTagsSettings_touchTarget__0udsd","card":"AppointmentTagsSettings_card__ZBmtN","cardBody":"AppointmentTagsSettings_cardBody__3h0K-"};